/* Adam's Frisör® — Home Studio motion layer.
   Shared by every adam-home-* section (and the final booking CTA) so that
   adding/removing/reordering any one homepage section in Theme Editor never
   breaks another. Loaded via its own <script defer> tag from each section —
   browsers dedupe the network request, and this file guards itself so the
   init logic only ever runs once regardless of how many <script> tags
   reference it.

   Two independent behaviours, both purely enhancement (no section requires
   JS to show its core content):
   - Reveal-on-scroll: elements are only ever hidden by a class THIS script
     adds (.adam-reveal-init). Without JS, [data-reveal] elements never get
     that class and stay fully visible in their normal position.
   - Parallax: elements with [data-parallax-speed] get a position-derived
     translate3d() nudge, rAF-throttled, skipped entirely when motion is off.

   Motion is considered "off" when EITHER:
   - prefers-reduced-motion: reduce, OR
   - settings.adams_home_motion_enabled is false (read from a data attribute
     any adam-home-* section root exposes).
*/
(function () {
  'use strict';

  if (window.__adamsHomeMotionInit) return;
  window.__adamsHomeMotionInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function readMotionEnabled() {
    var flagged = document.querySelector('[data-adam-motion-enabled]');
    if (!flagged) return true;
    return flagged.getAttribute('data-adam-motion-enabled') !== 'false';
  }

  var motionOn = !reduceMotion && readMotionEnabled();

  if (!motionOn) {
    document.documentElement.classList.add('adam-motion-off');
  }

  function initReveal() {
    var nodes = document.querySelectorAll('[data-reveal]:not([data-reveal-ready])');
    if (!nodes.length) return;

    if (!motionOn || !('IntersectionObserver' in window)) {
      // No class added: elements keep their default, fully visible state.
      nodes.forEach(function (el) { el.setAttribute('data-reveal-ready', '1'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('adam-reveal-visible');
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    nodes.forEach(function (el) {
      el.setAttribute('data-reveal-ready', '1');
      el.classList.add('adam-reveal-init');
      observer.observe(el);
    });
  }

  function initParallax() {
    if (!motionOn) return; // Skip the loop entirely — not just visually disabled.
    var nodes = Array.prototype.slice.call(document.querySelectorAll('[data-parallax-speed]'));
    if (!nodes.length) return;

    var ticking = false;

    function update() {
      ticking = false;
      var viewportHeight = window.innerHeight || 1;
      nodes.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < -200 || rect.top > viewportHeight + 200) return;
        var speed = parseFloat(el.getAttribute('data-parallax-speed')) || 0;
        var offset = (rect.top + rect.height / 2 - viewportHeight / 2) * -speed;
        el.style.transform = 'translate3d(0,' + offset.toFixed(2) + 'px,0)';
      });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  function boot() {
    initReveal();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme Editor: sections can be added/reordered without a full reload.
  document.addEventListener('shopify:section:load', initReveal);
})();
